import { Link } from 'react-router-dom'
import { Bot, Check, Zap, Rocket } from 'lucide-react'

const plans = [
  {
    id: 'agent',
    name: 'AI Agent',
    price: 999,
    period: 'month',
    icon: Zap,
    features: [
      'EFEE autopilot technology',
      'Autonomous research & analysis',
      'Recommendations with context',
      'Content creation (text, images, audio)',
      '5 tool integrations',
      'All API costs included'
    ]
  },
  {
    id: 'product',
    name: 'AI Product',
    price: 9999,
    period: 'month',
    icon: Rocket,
    featured: true,
    features: [
      'Everything in AI Agent',
      'Custom development from scratch',
      'Your own AI product/startup',
      'Full-stack (backend + frontend)',
      'Mobile app',
      'White-label',
      'Source code ownership',
      'Revenue share on growth'
    ]
  }
]

export default function Pricing() {
  return (
    <div className="py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Simple <span className="text-primary">Pricing</span>
          </h1>
          <p className="text-text-muted max-w-2xl mx-auto">
            Choose the plan that fits your needs. All plans include hosting, API costs, and 24/7 support.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {plans.map(plan => (
            <div 
              key={plan.id}
              className={`relative p-8 rounded-3xl border transition ${
                plan.featured 
                  ? 'bg-gradient-to-br from-primary/10 to-secondary/10 border-primary/50' 
                  : 'bg-glass border-glass-border'
              }`}
            >
              {plan.featured && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-primary text-dark text-sm font-bold rounded-full">
                  Most Popular
                </div>
              )}
              
              <div className="flex items-center gap-3 mb-6">
                <plan.icon className={`w-8 h-8 ${plan.featured ? 'text-primary' : 'text-text-muted'}`} />
                <h3 className="text-2xl font-bold text-white">{plan.name}</h3>
              </div>
              
              <div className="mb-8">
                <span className="text-4xl font-black text-white">${plan.price}</span>
                <span className="text-text-muted">/{plan.period}</span>
              </div>
              
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-success shrink-0 mt-0.5" />
                    <span className="text-text">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Link
                to="/register"
                className={`block w-full py-3 text-center font-bold rounded-xl transition ${
                  plan.featured
                    ? 'bg-primary text-dark hover:opacity-90'
                    : 'border border-glass-border text-white hover:bg-glass'
                }`}
              >
                Get Started
              </Link>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center p-8 rounded-2xl bg-glass border border-glass-border">
          <Bot className="w-10 h-10 text-primary mx-auto mb-4" />
          <h3 className="text-xl font-bold text-white mb-2">Need something custom?</h3>
          <p className="text-text-muted mb-4">
            We offer enterprise solutions for teams and organizations.
          </p>
          <a 
            href="mailto:hello@shkor.com" 
            className="inline-flex items-center gap-2 text-primary hover:underline"
          >
            Contact us
          </a>
        </div>
      </div>
    </div>
  )
}
